import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { HelmetProvider } from 'react-helmet-async';
import { WhatsAppFloatingButton } from "@/components/WhatsAppFloatingButton";

// Pages
import LandingPage from "@/pages/LandingPage";
import SponsorsPage from "@/pages/SponsorsPage";
import EventsPage from "@/pages/EventsPage";
import ContactPage from "@/pages/ContactPage";
import SpotlightPage from "@/pages/SpotlightPage";
import SpotlightSuccessPage from "@/pages/SpotlightSuccessPage";
import FeaturedJobPage from "@/pages/FeaturedJobPage";
import FeaturedJobSuccessPage from "@/pages/FeaturedJobSuccessPage";
import PostJobPage from "@/pages/PostJobPage";
import PostJobSuccessPage from "@/pages/PostJobSuccessPage";
import DirectoryPage from "@/pages/DirectoryPage";
import DirectoryDetailPage from "@/pages/DirectoryDetailPage";
import JobsPage from "@/pages/JobsPage";
import JobDetailPage from "@/pages/JobDetailPage";
import PropertiesPage from "@/pages/PropertiesPage";
import NewsListPage from "@/pages/NewsListPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

function App() {
  // Hide the WhatsApp bubble from admin screens to avoid covering the dashboard
  const isAdminRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
  return (
    <HelmetProvider>
      <PayPalScriptProvider options={{ clientId: PAYPAL_CLIENT_ID, currency: "GBP" }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/sponsors" element={<SponsorsPage />} />
            {/* Legacy /register URL — 301-style client redirect to sponsors (sponsorship centralised on paisley.org.uk) */}
            <Route path="/register" element={<Navigate to="/sponsors" replace />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/directory" element={<DirectoryPage />} />
            <Route path="/directory/:slug" element={<DirectoryDetailPage />} />
            <Route path="/jobs" element={<JobsPage />} />
            <Route path="/jobs/:slug" element={<JobDetailPage />} />
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/news" element={<NewsListPage />} />
            <Route path="/news/:slug" element={<NewsDetailPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/spotlight" element={<SpotlightPage />} />
            <Route path="/spotlight/success" element={<SpotlightSuccessPage />} />
            <Route path="/featured-job" element={<FeaturedJobPage />} />
            <Route path="/featured-job/success" element={<FeaturedJobSuccessPage />} />
            <Route path="/jobs/post" element={<PostJobPage />} />
            <Route path="/jobs/post/success" element={<PostJobSuccessPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-right" richColors />
          {!isAdminRoute && <WhatsAppFloatingButton />}
        </BrowserRouter>
      </PayPalScriptProvider>
    </HelmetProvider>
  );
}

export default App;
